import React__default from 'react';
import classNames from 'classnames';
import styles from './Header.scss.mjs';
import { PreventBlur } from '../../../PreventBlur/PreventBlur.mjs';
import { Header as Header$1 } from '../../../../../PanelCard/components/Header/Header.mjs';

function Header({
  title,
  show = false,
  onClose
}) {
  const headerClassNames = classNames(styles.Header, {
    [styles.show]: show
  });
  return /*#__PURE__*/React__default.createElement("div", {
    className: headerClassNames
  }, /*#__PURE__*/React__default.createElement(PreventBlur, {
    element: "div",
    className: styles.Interior
  }, /*#__PURE__*/React__default.createElement(Header$1, {
    title: title,
    onClose: onClose
  })));
}

export { Header };
